/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import { PropertyTranslationDefinition } from '@staffino/model';
import useBridge from './use-bridge-hook';

export default function usePropertyTranslation(
  translations: Record<string, unknown> | PropertyTranslationDefinition[],
  property: string,
  defaultValue: string,
): string {
  const bridge = useBridge();
  return Array.isArray(translations)
    ? defaultValue
    : (translations?.[bridge.localeId]?.[property] ?? defaultValue);
}
